import React from "react";
import { NavLink } from "react-router-dom";
import logoImg from "../logo.svg";
import { Icon } from "react-icons-kit";
import { menu } from "react-icons-kit/feather/menu";
import { arrowLeft } from "react-icons-kit/feather/arrowLeft";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../components/Sidebar";
import { useJwt } from "react-jwt";
import {
  EditMediaAPI,
  GetCategoryImage,
  GetMediaById,
  GetProductStatus,
  api_url,
} from "../apiconfig/authService";

function EditMedia(props) {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const setMediaTableViewMessage = props.setMessage;
  const setCategoryViewMessage = props.setMessage;

  const [categoryData, setCategoryData] = useState({});
  const [editedCategoryData, setEditedCategoryData] = useState({});

  const [mediaData, setMediaData] = useState({});
  const [editedMediaData, setEditedMediaData] = useState({});

  const [message, setMessage] = useState("");
  const [isMessageRed, setIsMessageRed] = useState(false);
  const { mediaid } = useParams();
  const [newImage, setNewImage] = useState(null);
  const [statusData, setStatusData] = useState([]);
  const imageInputRef = React.createRef();

  console.log(mediaData);

  useEffect(() => {
    (async () => {
      try {
        const response = await GetMediaById(
          mediaid,
          localStorage.getItem("accessToken")
        );
        setMediaData(response.data._doc);
        setEditedMediaData(response.data._doc);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const statusResponse = await GetProductStatus(
          localStorage.getItem("accessToken")
        );
        setStatusData(statusResponse.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  const handleTitleChange = (e) => {
    const temp = { ...editedMediaData };
    temp.title = e.target.value;
    setEditedMediaData(temp);
  };

  const handleImageChange = (e) => {
    setNewImage(e.target.files[0]);
  };

  const handleDiscardClick = async () => {
    if (imageInputRef.current) {
      imageInputRef.current.value = "";
    }
    setNewImage(null);
    const temp = { ...mediaData };
    setEditedMediaData(temp);
  };

  const handleStatusChange = (e) => {
    const temp = { ...editedMediaData };
    temp.statusid = e.target.value;
    setEditedMediaData(temp);
  };

  const validateInput = () => {
    if (editedMediaData.name === "") throw new Error("Name is required.");
  };

  console.log(editedMediaData);

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      // validateInput();
    } catch (error) {
      setIsMessageRed(true);
      setMessage(error.message);
      window.scrollTo(0, 0);
      return;
    }

    let response;
    const formData = new FormData();
    formData.append("mediaid", editedMediaData.mediaid);
    formData.append("title", editedMediaData.title);
    formData.append("statusid", editedMediaData.statusid);
    if (newImage) {
      formData.append("Image", newImage);
      formData.append("imagename", editedMediaData.image);
    }

    try {
      response = await EditMediaAPI(
        formData,
        localStorage.getItem("accessToken")
      );
      if (response.status === 200) {
        setMediaTableViewMessage(response.data.message);
        navigate("/media");
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        setIsMessageRed(true);
        setMessage(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        setIsMessageRed(true);
        setMessage("An error occurred. Please try again later.");
        window.scrollTo(0, 0);
      }
      console.log(err);
    }
  };

  return (
    <div className="dashboard-content">
      <Sidebar />
      {/* <div className="mobileOption d-flex align-items-center justify-content-between">
          <div  className="buyMore">
            <img className="img-fluid" src={logoImg} alt=""/>
          </div>
          <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
        </div> */}
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Edit Media</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/media" className="btn btn-primary">
              View All
            </NavLink>
          </div>
        </div>

        {message && (
          <div
            style={{ color: isMessageRed ? "red" : "black" }}
            className="alert alert-primary"
            role="alert"
          >
            {message}
          </div>
        )}

        <div
          role="tabpanel"
          className="personal-info tab-pane active storetab"
          id="pi"
        >
          {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="catName">Title</label>
              <input
                type="text"
                value={editedMediaData?.title}
                onChange={handleTitleChange}
                className="form-control custom-input my-3"
                id="catName"
                placeholder="Product Main Category Name"
              />
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="catImg">Image</label>
              <input
                type="file"
                ref={imageInputRef}
                className="form-control custom-input my-3"
                id="catImg"
                onChange={handleImageChange}
                placeholder="Product Main Category Image"
              />
              <img
                width="100px"
                height="100px"
                src={`${api_url}/product/category/getCategoryImage/${editedMediaData?.image}`}
              />
            </div>
            <div className="form-group col-sm-12 col-lg-12 mb-3">
              <label htmlFor="floatingInput">Status</label>
              <select
                className="form-select custom-input my-3"
                onChange={handleStatusChange}
                value={editedMediaData?.statusid}
              >
                {statusData?.map((item) => (
                  <option value={item.statusid}>{item.status}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-12 mb-3">
              <button
                type="submit"
                onClick={handleDiscardClick}
                className="btn btn-danger save-btn text-uppercase px-4 my-3"
              >
                Discard
              </button>{" "}
              &nbsp;
              <button
                type="submit"
                onClick={handleSubmitClick}
                className="btn btn-primary save-btn text-uppercase px-4 my-3"
              >
                Save
              </button>
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
}
export default EditMedia;
